import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styled from "styled-components";
import * as S from "~/components/plans/plans.style";
import { getColor, getSize } from "~/helpers/style";

const ToggleRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: ${getSize(1)};
  margin-top: ${getSize(0.5)};
`;

const CardShell = styled.div`
  flex: 1;
  min-width: 160px;
  max-width: 320px;
  min-height: 440px;
  border: 1px solid ${getColor("disabled")};
  border-radius: 18px;
  padding: ${getSize(3.3)} ${getSize(1.4)} ${getSize(2)};
  display: flex;
  flex-direction: column;
  gap: ${getSize(1.4)};
  background-color: ${getColor("white")};

  @media (max-width: 768px) {
    min-height: 210px;
    min-width: 100%;
  }

  @media (min-width: 769px) {
    min-height: 500px;
    padding-left: ${getSize(2)};
    padding-right: ${getSize(2)};
  }
`;

type Props = {
  gap?: number;
  cards?: number;
};

export const PlansSkeleton = ({ gap = 1, cards = 3 }: Props) => (
  <>
    <ToggleRow aria-hidden>
      <Skeleton width={72} height={20} borderRadius={4} />
      <Skeleton width={44} height={24} borderRadius={99} />
      <Skeleton width={88} height={20} borderRadius={4} />
      <Skeleton width={120} height={22} borderRadius={6} />
    </ToggleRow>
    <S.PlansGrid gap={gap}>
      {Array.from({ length: cards }, (_, i) => (
        <CardShell key={i}>
          <Skeleton width="55%" height={22} borderRadius={4} />
          <Skeleton width={96} height={36} borderRadius={8} />
          <Skeleton height={1} borderRadius={0} />
          <Skeleton width="90%" height={14} borderRadius={4} />
          <Skeleton width="85%" height={14} borderRadius={4} />
          <Skeleton width="70%" height={14} borderRadius={4} />
          <Skeleton width="100%" height={40} borderRadius={8} />
        </CardShell>
      ))}
    </S.PlansGrid>
  </>
);
